import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

import HumanColumn from "./HumanColumn";

export default function NewHuman({ humanId }) {
  const history = useHistory();

  const newHuman = useMemo(
    () => ({
      isNew: true,

      id: humanId,
      name: "New Human",
      createdAt: new Date().toISOString(),
      modifiedAt: new Date().toISOString(),
      pending: false,
      modified: false,
    }),
    [humanId]
  );

  const human = useSelector((state) =>
    state.humans.find((human) => human.id === humanId)
  );

  useEffect(() => {
    // On mount check if human with this ID already exists
    // to redirect to non-new-form page
    if (human) {
      history.replace({ pathname: `/h/${human.id}` });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <HumanColumn human={human || newHuman} />;
}

NewHuman.propTypes = {
  humanId: PropTypes.string,
};
